import { type UseQueryResult, useQuery } from 'react-query';
import {
  CustomReportsService,
  Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_ReportService_Dtos_CustomReport_CustomReportListDto_Wealthlane_ReportService_Application_Contracts,
} from '@wealthlane/api-services/wealthlane-report-service';
import { TableParamsType } from '../../types/common';

const useGetCustomReportList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  selectedReportType?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  | Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_ReportService_Dtos_CustomReport_CustomReportListDto_Wealthlane_ReportService_Application_Contracts
  | undefined,
  unknown
> => {
  const {
    createdFromDate,
    createdToDate,
    areaTypeId,
    categoryTypeId,
    filter,
    sorting,
    skipCount,
    maxResultCount,
  } = tableInfo;
  const customReportList = useQuery(
    [
      'getCustomReportList',
      createdFromDate,
      createdToDate,
      categoryTypeId,
      areaTypeId,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      selectedReportType,
    ],
    async () => {
      if (selectedReportType === 'customReport') {
        return await handleRequest(
          CustomReportsService.getApiReportApiAppCustomReportsCustomReportList(
            createdFromDate,
            createdToDate,
            categoryTypeId,
            areaTypeId,
            filter,
            sorting,
            skipCount,
            maxResultCount
          )
        );
      }
    }
  );

  return customReportList;
};

export default useGetCustomReportList;
